<template>
  <FundoValidation :provider_id="user.enterprise.id" />
</template>
<script>
import FundoValidation from "@/components/FundoValidation";
import { mapGetters } from "vuex";

export default {
  components: {
    FundoValidation,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
